// 实验组返回页面时检测主题版本更新并自动刷新

(function () {
  const experimentName = 'theme_id_return_refresh';
  const experimentGroupIds = { false: 38, true: 39 };
  const minimumHiddenDuration = 5 * 60 * 1000;
  const themeIdSelector = 'meta[name="jjb-theme-id"]';
  const currentThemeId = document.querySelector(themeIdSelector)?.content;

  if (!currentThemeId) return;

  let leftAt;
  let pendingCheck;
  let checkSequence = 0;
  let isRefreshing = false;

  function isTestEnvironment() {
    try {
      return (
        window.location.hostname.includes('localhost') ||
        window.location.hostname.includes('127.0.0.1') ||
        window.location.hostname.includes('shopifypreview.com') ||
        window.localStorage.getItem('_shop_mode') === 'test'
      );
    } catch (error) {
      return false;
    }
  }

  async function isRefreshEnabled() {
    try {
      let experiment;

      if (
        isTestEnvironment() &&
        typeof window.jjbUtils?.overrideExperiment === 'function'
      ) {
        experiment = await window.jjbUtils.overrideExperiment(experimentName);
      } else {
        await window.statsigReady;
        experiment = await window.statsigClient?.getExperiment(experimentName);
      }

      const enabled = experiment?.get('enable', false) === true;
      window.zlog?.recordExperimentGroup?.(
        `${experimentName}:enable`,
        experimentGroupIds[String(enabled)] ?? 40,
      );
      return enabled;
    } catch (error) {
      return false;
    }
  }

  function trackPageReload() {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'home_reload_pageview');
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'home_reload_pageview' });
      }
    } catch (error) {
      // 埋点失败时仍继续刷新页面。
    }
  }

  function checkThemeUpdate() {
    if (pendingCheck || isRefreshing) return pendingCheck;

    const sequence = ++checkSequence;
    const checkPromise = (async function () {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('__jjb_theme_probe', Date.now().toString());

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
        });
        if (!response.ok) return;

        const html = await response.text();
        const latestThemeId = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(themeIdSelector)?.content;

        if (
          sequence === checkSequence &&
          !isRefreshing &&
          latestThemeId &&
          latestThemeId !== currentThemeId
        ) {
          isRefreshing = true;
          trackPageReload();
          window.location.reload();
        }
      } catch (error) {
        // 版本探测失败时保持当前页面可用，并在下次返回页面时重试。
      }
    })();

    pendingCheck = checkPromise;
    checkPromise.then(function () {
      if (pendingCheck === checkPromise && sequence === checkSequence) {
        pendingCheck = undefined;
      }
    });

    return checkPromise;
  }

  function markPageLeft() {
    if (leftAt === undefined) leftAt = Date.now();
  }

  function checkAfterReturn() {
    if (leftAt === undefined) return;

    const hiddenDuration = Date.now() - leftAt;
    leftAt = undefined;

    if (hiddenDuration < minimumHiddenDuration) return;
    return checkThemeUpdate();
  }

  isRefreshEnabled().then(function (enabled) {
    if (!enabled) return;

    if (document.visibilityState === 'hidden') {
      markPageLeft();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        markPageLeft();
        return;
      }

      return checkAfterReturn();
    });

    window.addEventListener('pagehide', markPageLeft);

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) return checkAfterReturn();
    });
  });
})();
